import EfSection from '@elem/ui/ef-section';
import EfSectionLRIcons from '@elem/ui/ef-section-l-r-icons';
import EfSpec from '@elem/ui/ef-spec';
import EfTab, { EfTabItemProps } from '@elem/ui/ef-tab';
import EFCoffeeMaker from 'elem/ui-assets/icons/appliances/EFCoffeeMaker';
import EFFan from 'elem/ui-assets/icons/appliances/EFFan';
import EFPhone from 'elem/ui-assets/icons/appliances/EFPhone';
import EFRefrigerator from 'elem/ui-assets/icons/appliances/EFRefrigerator';
import EFTV from 'elem/ui-assets/icons/appliances/EFTV';
import EFWiFi from 'elem/ui-assets/icons/appliances/EFWiFi';
import { useState } from 'react';
import EFLaptop from 'elem/ui-assets/icons/appliances/EFLaptop';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import EFWashingMachine from '@elem/ui-assets/icons/appliances/EFWashingMachine';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const listTabH: EfTabItemProps[] = [
        {
            type: 'a1',
            title: t('L_item1_tab'),
        },
    ];
    const tabObj: any = {
        a1: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725268093600/vs_eu.png',
            title: t('L_item1_title'),
            desc: t('L_item1_desc'),
            list: [
                {
                    title: t('L_item1_app1'),
                    desc: t('L_item1_app1_time'),
                    icon: <EFLaptop />,
                },
                {
                    title: t('L_item1_app2'),
                    desc: t('L_item1_app2_time'),
                    icon: <EFPhone />,
                },
                {
                    title: t('L_item1_app3'),
                    desc: t('L_item1_app3_time'),
                    icon: <EFFan />,
                },
                {
                    title: t('L_item1_app4'),
                    desc: t('L_item1_app4_time'),
                    icon: <EFRefrigerator />,
                },
                {
                    title: t('L_item1_app5'),
                    desc: t('L_item1_app5_time'),
                    icon: <EFTV />,
                },
                {
                    title: t('L_item1_app6'),
                    desc: t('L_item1_app6_time'),
                    icon: <EFWiFi />,
                },
                {
                    title: t('L_item1_app7'),
                    desc: t('L_item1_app7_time'),
                    icon: <EFWashingMachine />,
                },
                {
                    title: t('L_item1_app8'),
                    desc: t('L_item1_app8_time'),
                    icon: <EFCoffeeMaker />,
                },
            ],
        },
    };
    // 选中的tab
    const [activeType, setActiveType] = useState('a1');
    const [activeItem, setActiveItem] = useState(tabObj[activeType]);
    // tab切换回调
    const activeTypeCallback = (item: EfTabItemProps) => {
        setActiveType(item.type);
        setActiveItem(tabObj[item.type] || tabObj['a1']);
    };
    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfSection label={t('L_label')} title={t('L_title')} />
            <EfSectionLRIcons pc={activeItem.pc} title={activeItem.title} desc={activeItem.desc} list={activeItem.list} />
            <EfTab list_name={t('L_title')} items={listTabH} activeType={activeType} onChange={activeTypeCallback} />
        </div>
    );
}
